import useHttp from './useHttp';
import AuthContext from '../context/authContext';
import { useContext } from 'react';

export const useGroups = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const fetchGroups = async () => {
    return new Promise(async (resolve, reject) => {
      try {
        const responseData = await sendRequest({
          url: '/api/v1/group',
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + authCtx.token,
          },
        });

        resolve(responseData);
      } catch (error) {
        reject(error);
      }
    });
  };

  return {
    isLoading,
    error,
    fetchGroups,
  };
};
